
import Vue from 'vue'

export default Vue.extend({
   name: 'BreadcrumbComponent',
   props: {
      crumbs: Array as () => Breadcrumb[],
   },
})
